<!-- CTA Section -->
<section
  class="flex flex-col gap-8 rounded-[--tui-radius-l] bg-background-neutral-1 p-8 text-center md:p-12"
>
  <h2 class="text-3xl font-bold md:text-4xl">
    Ready to Join Our Partner Network?
  </h2>
  <p class="text-balance text-xl">
    Take the next step and unlock exclusive benefits, priority support, and
    co-marketing opportunities to accelerate your business growth
  </p>
  <div class="flex flex-col gap-2">
    <div class="flex flex-col justify-center gap-4 sm:flex-row">
      <a
        size="l"
        tuiButton
        type="button"
        [href]="'mailto:' + emailSales"
        data-umami-event="partners-cta-contact-sales"
      >
        Apply to Partner Program
      </a>
      <a
        appearance="outline"
        iconEnd="@tui.external-link"
        size="l"
        tuiAppearanceMode="checked"
        tuiButton
        type="button"
        [href]="bookingUrl"
        target="_blank"
        data-umami-event="partners-cta-book-meeting"
      >
        Book a Meeting
      </a>
    </div>
    <p class="text-text-tertiary text-sm">
      Questions?
      <a
        class="text-primary hover:underline"
        [href]="discordUrl"
        target="_blank"
      >
        Join our Discord
      </a>
      or
      <a class="text-primary hover:underline" routerLink="/contact/">
        contact us </a
      >.
    </p>
  </div>
</section>
